import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO";
import { Helmet } from "react-helmet-async";
import {
  FaCheckCircle,
  FaLeaf,
  FaCertificate,
  FaBarcode,
  FaGlassWhiskey,
  FaSnowflake,
  FaBoxOpen,
  FaShieldAlt,
  FaAppleAlt,
  FaBlender,
  FaCocktail,
  FaIceCream,
  FaCoffee,
  FaBirthdayCake,
  FaChild,
  FaDownload,
  FaTimes,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaSun,
} from "react-icons/fa";

const FruitJuicesPulp = () => {
  const { t } = useTranslation();
  const [activeProduct, setActiveProduct] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const products = [
    {
      name: t("fruitJuicesPulp.products.pineapplePulp.name"),
      type: "pulp",
      images: [
        "/images/products/pineapple-pulp-pack.webp",
        "/images/products/pineapple-pulp-texture.webp",
      ],
      image: "🍍",
      color: "from-yellow-400 to-amber-500",
      appearance: t("fruitJuicesPulp.products.pineapplePulp.appearance"),
      aroma: t("fruitJuicesPulp.products.pineapplePulp.aroma"),
      flavour: t("fruitJuicesPulp.products.pineapplePulp.flavour"),
      texture: t("fruitJuicesPulp.products.pineapplePulp.texture"),
      ingredient: t("fruitJuicesPulp.products.pineapplePulp.ingredient"),
      usage: [
        t("fruitJuicesPulp.products.pineapplePulp.usage.0"),
        t("fruitJuicesPulp.products.pineapplePulp.usage.1"),
        t("fruitJuicesPulp.products.pineapplePulp.usage.2"),
        t("fruitJuicesPulp.products.pineapplePulp.usage.3"),
        t("fruitJuicesPulp.products.pineapplePulp.usage.4"),
      ],
      dataSheet: "/images/DataSheet/pineapple-pulp.jpg",
    },
    {
      name: t("fruitJuicesPulp.products.mangoPulp.name"),
      type: "pulp",
      images: [
        "/images/products/mango-pulp-pack.webp",
        "/images/products/mango-pulp-texture.webp",
      ],
      image: "🥭",
      color: "from-orange-400 to-red-500",
      appearance: t("fruitJuicesPulp.products.mangoPulp.appearance"),
      aroma: t("fruitJuicesPulp.products.mangoPulp.aroma"),
      flavour: t("fruitJuicesPulp.products.mangoPulp.flavour"),
      texture: t("fruitJuicesPulp.products.mangoPulp.texture"),
      ingredient: t("fruitJuicesPulp.products.mangoPulp.ingredient"),
      usage: [
        t("fruitJuicesPulp.products.mangoPulp.usage.0"),
        t("fruitJuicesPulp.products.mangoPulp.usage.1"),
        t("fruitJuicesPulp.products.mangoPulp.usage.2"),
        t("fruitJuicesPulp.products.mangoPulp.usage.3"),
      ],
      dataSheet: "/images/DataSheet/mango-pulp.jpg",
    },
    {
      name: t("fruitJuicesPulp.products.mangoDrink.name"),
      type: "drink",
      images: [
        "/images/products/mango-drink-bottle.webp",
        "/images/products/mango-drink-glass.webp",
      ],
      image: "🥭",
      color: "from-yellow-400 to-orange-500",
      ingredients: t("fruitJuicesPulp.products.mangoDrink.ingredients"),
      volumes: t("fruitJuicesPulp.products.mangoDrink.volumes"),
      tasteProfile: t("fruitJuicesPulp.products.mangoDrink.tasteProfile"),
      servingIdeas: [
        t("fruitJuicesPulp.products.mangoDrink.servingIdeas.0"),
        t("fruitJuicesPulp.products.mangoDrink.servingIdeas.1"),
        t("fruitJuicesPulp.products.mangoDrink.servingIdeas.2"),
      ],
      dataSheet: "/images/DataSheet/mango-drink.jpg",
    },
    {
      name: t("fruitJuicesPulp.products.pineappleDrink.name"),
      type: "drink",
      images: [
        "/images/products/pineapple-drink-bottle.webp",
        "/images/products/pineapple-drink-glass.webp",
      ],
      image: "🍍",
      color: "from-yellow-300 to-yellow-600",
      ingredients: t("fruitJuicesPulp.products.pineappleDrink.ingredients"),
      volumes: t("fruitJuicesPulp.products.pineappleDrink.volumes"),
      tasteProfile: t("fruitJuicesPulp.products.pineappleDrink.tasteProfile"),
      servingIdeas: [
        t("fruitJuicesPulp.products.pineappleDrink.servingIdeas.0"),
        t("fruitJuicesPulp.products.pineappleDrink.servingIdeas.1"),
        t("fruitJuicesPulp.products.pineappleDrink.servingIdeas.2"),
      ],
      dataSheet: "/images/DataSheet/pineapple-drink.jpg",
    },
    {
      name: t("fruitJuicesPulp.products.tropicalMixDrink.name"),
      type: "drink",
      images: [
        "/images/products/tropical-mix-drink-bottle.webp",
        "/images/products/tropical-mix-drink-glass.webp",
      ],
      image: "🍹",
      color: "from-pink-400 to-orange-500",
      ingredients: t("fruitJuicesPulp.products.tropicalMixDrink.ingredients"),
      volumes: t("fruitJuicesPulp.products.tropicalMixDrink.volumes"),
      tasteProfile: t("fruitJuicesPulp.products.tropicalMixDrink.tasteProfile"),
      servingIdeas: [
        t("fruitJuicesPulp.products.tropicalMixDrink.servingIdeas.0"),
        t("fruitJuicesPulp.products.tropicalMixDrink.servingIdeas.1"),
        t("fruitJuicesPulp.products.tropicalMixDrink.servingIdeas.2"),
      ],
      dataSheet: "/images/DataSheet/mix-drink.jpg",
    },
    {
      name: t("fruitJuicesPulp.products.papayaDrink.name"),
      type: "drink",
      images: [
        "/images/products/papaya-drink-bottle.webp",
        "/images/products/papaya-drink-glass.webp",
      ],
      image: "🍈",
      color: "from-orange-300 to-pink-400",
      ingredients: t("fruitJuicesPulp.products.papayaDrink.ingredients"),
      volumes: t("fruitJuicesPulp.products.papayaDrink.volumes"),
      tasteProfile: t("fruitJuicesPulp.products.papayaDrink.tasteProfile"),
      servingIdeas: [
        t("fruitJuicesPulp.products.papayaDrink.servingIdeas.0"),
        t("fruitJuicesPulp.products.papayaDrink.servingIdeas.1"),
        t("fruitJuicesPulp.products.papayaDrink.servingIdeas.2"),
      ],
      dataSheet: "/images/DataSheet/papaya-drink.jpg",
    },
  ];

  const certifications = [
    {
      name: t("dehydratedFruits.certifications.brc.name"),
      image: "/images/certifications/BRC.webp",
      alt: t("dehydratedFruits.certifications.brc.name"),
      description: t("dehydratedFruits.certifications.brc.description"),
      icon: "🏆",
    },
    {
      name: t("dehydratedFruits.certifications.eu.name"),
      image: "/images/certifications/EU.webp",
      alt: t("dehydratedFruits.certifications.eu.name"),
      description: t("dehydratedFruits.certifications.eu.description"),
      icon: "🇪🇺",
    },
    {
      name: t("dehydratedFruits.certifications.usda.name"),
      image: "/images/certifications/USDA.webp",
      alt: t("dehydratedFruits.certifications.usda.name"),
      description: t("dehydratedFruits.certifications.usda.description"),
      icon: "🇺🇸",
    },
    {
      name: t("dehydratedFruits.certifications.jas.name"),
      image: "/images/certifications/JAS.webp",
      alt: t("dehydratedFruits.certifications.jas.name"),
      description: t("dehydratedFruits.certifications.jas.description"),
      icon: "🇯🇵",
    },
    {
      name: t("dehydratedFruits.certifications.naturland.name"),
      image: "/images/certifications/Naturland.webp",
      alt: t("dehydratedFruits.certifications.naturland.name"),
      description: t("dehydratedFruits.certifications.naturland.description"),
      icon: "🌱",
    },
    {
      name: t("dehydratedFruits.certifications.fairtrade.name"),
      image: "/images/certifications/FairTrade.webp",
      alt: t("dehydratedFruits.certifications.fairtrade.name"),
      description: t("dehydratedFruits.certifications.fairtrade.description"),
      icon: "🤝",
    },
    {
      name: t("dehydratedFruits.certifications.fda.name"),
      image: "/images/certifications/FDA.webp",
      alt: t("dehydratedFruits.certifications.fda.name"),
      description: t("dehydratedFruits.certifications.fda.description"),
      icon: "✅",
    },
  ];

  // Navigate images
  const nextImage = () => {
    setActiveImageIndex((prev) =>
      prev === products[activeProduct].images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setActiveImageIndex((prev) =>
      prev === 0 ? products[activeProduct].images.length - 1 : prev - 1
    );
  };

  // FAQ Keys
  const faqKeys = ["organic", "shelfLife", "storage", "customization"];

  // Reset image index when product changes
  const handleProductChange = (index) => {
    setActiveProduct(index);
    setActiveImageIndex(0);
  };

  // Download modal component
  const DownloadModal = () => (
    <AnimatePresence>
      {showDownloadModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setShowDownloadModal(false)}
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 20 }}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header - Fixed */}
            <div className="bg-gradient-to-r from-orange-600 to-yellow-600 text-white p-6 rounded-t-2xl flex justify-between items-center flex-shrink-0">
              <div>
                <h3 className="text-2xl font-bold mb-1">
                  {t("fruitJuicesPulp.downloadModal.title")}
                </h3>
                <p className="text-orange-100 text-sm">
                  {t("fruitJuicesPulp.downloadModal.subtitle")}
                </p>
              </div>
              <button
                onClick={() => setShowDownloadModal(false)}
                className="text-white hover:bg-white/20 rounded-full p-2 transition-all duration-300"
              >
                <FaTimes className="text-2xl" />
              </button>
            </div>

            {/* Product List - Scrollable */}
            <div className="p-6 space-y-3 overflow-y-auto flex-1">
              {products.map((product, index) => (
                <motion.a
                  key={index}
                  href={product.dataSheet}
                  download
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center justify-between p-4 bg-gradient-to-r from-orange-50 to-yellow-50 dark:from-gray-700 dark:to-gray-600 rounded-xl hover:shadow-lg hover:scale-[1.02] transition-all duration-300 group"
                >
                  <div className="flex items-center space-x-4">
                    {/* Product Icon */}
                    <div
                      className={`w-14 h-14 bg-gradient-to-br ${product.color} rounded-xl flex items-center justify-center text-3xl shadow-md`}
                    >
                      {product.image}
                    </div>

                    {/* Product Info */}
                    <div>
                      <h4 className="font-bold text-gray-900 dark:text-white group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors">
                        {product.name}
                      </h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {t("fruitJuicesPulp.downloadModal.productInfo")}
                      </p>
                    </div>
                  </div>

                  {/* Download Icon */}
                  <div className="bg-orange-600 text-white rounded-full p-3 group-hover:bg-orange-700 group-hover:scale-110 transition-all duration-300 shadow-md">
                    <FaDownload className="text-xl" />
                  </div>
                </motion.a>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  const commonFeatures = [
    {
      icon: <FaAppleAlt />,
      title: t("fruitJuicesPulp.features.organicFruit.title"),
      desc: t("fruitJuicesPulp.features.organicFruit.desc"),
    },
    {
      icon: <FaBlender />,
      title: t("fruitJuicesPulp.features.cleanProcessing.title"),
      desc: t("fruitJuicesPulp.features.cleanProcessing.desc"),
    },
    {
      icon: <FaGlassWhiskey />,
      title: t("fruitJuicesPulp.features.flexibleFormats.title"),
      desc: t("fruitJuicesPulp.features.flexibleFormats.desc"),
    },
    {
      icon: <FaLeaf />,
      title: t("fruitJuicesPulp.features.certifiedOrganic.title"),
      desc: t("fruitJuicesPulp.features.certifiedOrganic.desc"),
    },
  ];

  const applications = [
    { icon: <FaCocktail />, text: t("fruitJuicesPulp.applications.mocktails") },
    { icon: <FaBlender />, text: t("fruitJuicesPulp.applications.smoothies") },
    { icon: <FaIceCream />, text: t("fruitJuicesPulp.applications.desserts") },
    { icon: <FaCoffee />, text: t("fruitJuicesPulp.applications.cafeRetail") },
    {
      icon: <FaBirthdayCake />,
      text: t("fruitJuicesPulp.applications.baking"),
    },
    {
      icon: <FaChild />,
      text: t("fruitJuicesPulp.applications.kidsBeverages"),
    },
  ];

  return (
    <>
      {/* SEO Component */}
      <SEO
        title="Organic Fruit Juices & Pulp | Premium Mango, Pineapple & Tropical Drinks"
        description="100% organic fruit juices and pulp from Sri Lanka. BRC certified, no added sugar or preservatives. Mango, pineapple, papaya, and tropical mix drinks. Natural fruit pulp for smoothies, desserts & beverages. 24-month shelf life."
        keywords="organic fruit juice Sri Lanka, organic fruit pulp, mango pulp organic, pineapple pulp organic, organic tropical fruit juice, no added sugar fruit juice, BRC certified fruit juice, organic mango drink, organic pineapple drink, organic papaya drink, tropical fruit mix drink, natural fruit pulp, organic smoothie base, fruit juice no preservatives, USDA organic fruit juice, EU organic fruit juice, Ceylon fruit juice, organic fruit beverage, natural fruit drink, organic juice for kids, premium organic juice, traceable organic juice, sustainable fruit juice"
        image="https://worganaturals.com/images/products/organic-fruit-juices-pulp-collection.webp"
        url="/products/fruit-juices-pulp"
        type="product"
        productSchema={true}
        category="Organic Beverages & Food Ingredients"
        brand="Worga Naturals"
        availability="InStock"
        price="3.49"
        currency="USD"
        sku="FJP-MANGO-350"
      />

      {/* Additional Structured Data */}
      <Helmet>
        {/* Product Schema with Variants */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: "Organic Fruit Juices & Pulp",
            description:
              "100% organic fruit juices and pulp from certified organic farms in Sri Lanka. Hygienically processed with no added sugar, preservatives, or artificial flavours. Available in mango, pineapple, papaya pulp and ready-to-drink formats.",
            brand: {
              "@type": "Brand",
              name: "Worga Naturals",
            },
            manufacturer: {
              "@type": "Organization",
              name: "Worga Naturals (Pvt) Ltd.",
              address: {
                "@type": "PostalAddress",
                streetAddress: "No. 152/G, Meepavita, Udamapitigama",
                addressLocality: "Dompe",
                postalCode: "11680",
                addressCountry: "LK",
              },
            },
            image: [
              "https://worganaturals.com/images/products/organic-mango-pulp-bottle.webp",
              "https://worganaturals.com/images/products/organic-pineapple-pulp-bottle.webp",
              "https://worganaturals.com/images/products/organic-mango-drink-bottle.webp",
              "https://worganaturals.com/images/products/organic-pineapple-drink-bottle.webp",
              "https://worganaturals.com/images/products/organic-tropical-mix-drink-bottle.webp",
              "https://worganaturals.com/images/products/organic-papaya-drink-bottle.webp",
            ],
            category: "Organic Beverages & Food Ingredients",
            offers: {
              "@type": "AggregateOffer",
              availability: "https://schema.org/InStock",
              priceCurrency: "USD",
              lowPrice: "2.99",
              highPrice: "5.99",
              offerCount: "6",
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "98",
            },
            additionalProperty: [
              {
                "@type": "PropertyValue",
                name: "Shelf Life",
                value: "24 months",
              },
              {
                "@type": "PropertyValue",
                name: "Pack Sizes",
                value: "200ml, 350ml glass bottles (custom available)",
              },
              {
                "@type": "PropertyValue",
                name: "Certifications",
                value: "BRC, EU Organic, USDA Organic, JAS, Naturland",
              },
              {
                "@type": "PropertyValue",
                name: "Origin",
                value: "Sri Lanka",
              },
              {
                "@type": "PropertyValue",
                name: "Processing Method",
                value:
                  "Hygienically pulped, filtered, filled, seamed, and sterilized",
              },
              {
                "@type": "PropertyValue",
                name: "Free From",
                value:
                  "No added sugar, preservatives, artificial flavours or colours",
              },
            ],
            hasVariant: [
              {
                "@type": "Product",
                name: "Organic Pineapple Pulp with Own Fiber",
                description:
                  "100% organic pineapple pulp with natural fiber. Perfect for smoothies, desserts, baking, and sauces.",
                sku: "FJP-PINE-PULP-350",
                category: "Organic Fruit Pulp",
                offers: {
                  "@type": "Offer",
                  price: "4.99",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
              {
                "@type": "Product",
                name: "Organic Mango Pulp",
                description:
                  "100% organic TJC mango pulp. Ideal for beverage bases, ice creams, desserts, and confectionery.",
                sku: "FJP-MANGO-PULP-350",
                category: "Organic Fruit Pulp",
                offers: {
                  "@type": "Offer",
                  price: "5.49",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
              {
                "@type": "Product",
                name: "Organic Mango Drink",
                description:
                  "Ready-to-drink organic mango beverage with clean mango notes and refreshing drinkability. No added sugar.",
                sku: "FJP-MANGO-200",
                category: "Organic Ready-to-Drink Beverages",
                offers: {
                  "@type": "Offer",
                  price: "2.99",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
              {
                "@type": "Product",
                name: "Organic Pineapple Drink",
                description:
                  "Ready-to-drink organic pineapple beverage with bright, tangy flavor and crisp finish. No added sugar.",
                sku: "FJP-PINE-200",
                category: "Organic Ready-to-Drink Beverages",
                offers: {
                  "@type": "Offer",
                  price: "2.99",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
              {
                "@type": "Product",
                name: "Organic Tropical Fruit Mix Drink",
                description:
                  "Balanced blend of organic mango, pineapple, and papaya. Perfect for brunch beverages and tropical mocktails.",
                sku: "FJP-TROPICAL-350",
                category: "Organic Ready-to-Drink Beverages",
                offers: {
                  "@type": "Offer",
                  price: "3.49",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
              {
                "@type": "Product",
                name: "Organic Papaya Drink",
                description:
                  "Soft, mellow organic papaya drink with gentle sweetness. Ideal breakfast companion and smoothie base.",
                sku: "FJP-PAPAYA-350",
                category: "Organic Ready-to-Drink Beverages",
                offers: {
                  "@type": "Offer",
                  price: "3.49",
                  priceCurrency: "USD",
                  availability: "https://schema.org/InStock",
                },
              },
            ],
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Are these products truly organic?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes—certified EU, USDA (NOP), JAS, and Naturland Organic. Full traceability documentation available by batch.",
                },
              },
              {
                "@type": "Question",
                name: "What is the shelf life of these products?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "24 months from date of manufacture when stored properly. Once opened, refrigerate and consume drinks within 2-3 days for best quality.",
                },
              },
              {
                "@type": "Question",
                name: "How should I store these products?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Store unopened products in a cool, dry place away from direct sunlight. Do not freeze glass bottles. After opening, refrigerate immediately and use within 2-3 days.",
                },
              },
              {
                "@type": "Question",
                name: "Can I get custom volumes or private labeling?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! We offer custom bottle sizes, private label options, and bulk packaging solutions. Contact our sales team to discuss your specific requirements.",
                },
              },
              {
                "@type": "Question",
                name: "What is the difference between pulp and ready-to-drink products?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pulp products are 100% concentrated fruit with natural fiber, ideal for use as ingredients in smoothies, desserts, and food service. Ready-to-drink products are diluted with water for immediate consumption, perfect for on-the-go refreshment and café service.",
                },
              },
              {
                "@type": "Question",
                name: "Are there any added sugars or preservatives?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No—our fruit juices and pulps contain no added sugars, preservatives, artificial flavours, or colours. They are 100% natural and organic.",
                },
              },
            ],
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://worganaturals.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Products",
                item: "https://worganaturals.com/products",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Fruit Juices & Pulp",
                item: "https://worganaturals.com/products/fruit-juices-pulp",
              },
            ],
          })}
        </script>

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Worga Naturals",
            url: "https://worganaturals.com",
            logo: "https://worganaturals.com/images/logo.png",
            description:
              "Premium organic products from Sri Lanka including fruit juices, pulp, coconut water, and natural preserves.",
            address: {
              "@type": "PostalAddress",
              streetAddress: "No. 152/G, Meepavita, Udamapitigama",
              addressLocality: "Dompe",
              postalCode: "11680",
              addressCountry: "LK",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+94-XX-XXXXXXX",
              contactType: "Customer Service",
              availableLanguage: ["English", "Sinhala"],
            },
            sameAs: [
              "https://www.facebook.com/worganaturals",
              "https://www.instagram.com/worganaturals",
              "https://www.linkedin.com/company/worganaturals",
            ],
          })}
        </script>

        {/* Recipe/HowTo Schema for Usage */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "HowTo",
            name: "How to Use Organic Fruit Pulp",
            description:
              "Simple ways to use organic fruit pulp in smoothies, desserts, and beverages",
            step: [
              {
                "@type": "HowToStep",
                name: "Smoothie Base",
                text: "Add 2-3 tablespoons of organic fruit pulp to your blender with ice, yogurt, or milk for a nutritious smoothie.",
              },
              {
                "@type": "HowToStep",
                name: "Dessert Topping",
                text: "Spoon organic fruit pulp over ice cream, yogurt, or pancakes for natural sweetness.",
              },
              {
                "@type": "HowToStep",
                name: "Beverage Mix",
                text: "Dilute fruit pulp with water or sparkling water for a refreshing natural drink.",
              },
              {
                "@type": "HowToStep",
                name: "Baking Ingredient",
                text: "Incorporate fruit pulp into muffins, cakes, or bread recipes for added moisture and flavor.",
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-yellow-50 to-pink-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        {/* Download Modal */}
        <DownloadModal />
        {/* Spacer for navbar */}
        <div className="h-24"></div>

        {/* Hero Section */}
        <section className="container mx-auto px-4 py-16 md:py-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-5xl mx-auto text-center"
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-block mb-6"
            >
              <span className="px-6 py-2 bg-gradient-to-r from-orange-600 to-pink-600 text-white rounded-full text-sm font-semibold shadow-lg">
                {t("fruitJuicesPulp.hero.badge")}
              </span>
            </motion.div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
              <span className="text-gray-900 dark:text-white">
                {t("fruitJuicesPulp.hero.title.part1")}{" "}
              </span>
              <span className="text-orange-600 dark:text-orange-500">
                {t("fruitJuicesPulp.hero.title.part2")}
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 leading-relaxed max-w-4xl mx-auto mb-8">
              {t("fruitJuicesPulp.hero.description")}
            </p>

            {/* Traceability Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="inline-flex items-center space-x-3 bg-white dark:bg-gray-800 rounded-full px-6 py-3 shadow-lg"
            >
              <FaBarcode className="text-orange-600 text-2xl" />
              <span className="text-gray-700 dark:text-gray-300 font-medium">
                {t("fruitJuicesPulp.hero.traceability")}
              </span>
            </motion.div>
          </motion.div>
        </section>

        {/* Common Features */}
        <section className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-6xl mx-auto"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 dark:text-white mb-12">
              {t("fruitJuicesPulp.features.title")}
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {commonFeatures.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 text-center hover:shadow-2xl transition-all duration-300"
                >
                  <div className="text-5xl text-orange-600 mb-4 flex justify-center">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {feature.desc}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Applications Section */}
            <div className="bg-gradient-to-r from-orange-600 to-pink-600 rounded-2xl p-8 text-white shadow-2xl">
              <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center">
                {t("fruitJuicesPulp.applications.title")}
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {applications.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/30 transition-all duration-300"
                  >
                    <div className="text-3xl mb-2 flex justify-center">
                      {item.icon}
                    </div>
                    <p className="text-sm font-semibold">{item.text}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </section>

        {/* Product Family */}
        <section className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-7xl mx-auto"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 dark:text-white mb-12">
              {t("fruitJuicesPulp.productFamily.title")}
            </h2>

            {/* Product Tabs */}
            <div className="flex flex-wrap justify-center gap-3 mb-12">
              {products.map((product, index) => (
                <button
                  key={index}
                  onClick={() => handleProductChange(index)}
                  className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                    activeProduct === index
                      ? "bg-gradient-to-r from-orange-600 to-pink-600 text-white shadow-lg scale-105"
                      : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:shadow-md"
                  }`}
                >
                  <span className="hidden lg:inline">{product.name}</span>
                  <span className="lg:hidden">
                    {product.image} {product.name.split(" ")[1]}
                  </span>
                </button>
              ))}
            </div>

            {/* Active Product Card */}
            <motion.div
              key={activeProduct}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl overflow-hidden"
            >
              <div className="grid md:grid-cols-2 gap-8">
                {/* Product Image with Carousel */}
                {/* Product Image Slider */}
                <div
                  className={`bg-gradient-to-br ${products[activeProduct].color} flex items-center justify-center p-12 md:p-16 relative overflow-hidden`}
                >
                  {/* Image Display */}
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={activeImageIndex}
                      initial={{ opacity: 0, scale: 0.9, x: 100 }}
                      animate={{ opacity: 1, scale: 1, x: 0 }}
                      exit={{ opacity: 0, scale: 0.9, x: -100 }}
                      transition={{ duration: 0.4, ease: "easeInOut" }}
                      className="w-full h-full flex items-center justify-center"
                    >
                      <img
                        src={products[activeProduct].images[activeImageIndex]}
                        alt={`${products[activeProduct].name} - ${t(
                          "dehydratedFruits.navigation.view"
                        )} ${activeImageIndex + 1}`}
                        className="max-w-full max-h-[500px] object-contain drop-shadow-2xl rounded-lg"
                        onError={(e) => {
                          e.target.style.display = "none";
                          const fallback = document.createElement("div");
                          fallback.className = "text-9xl";
                          fallback.textContent = products[activeProduct].image;
                          e.target.parentElement.appendChild(fallback);
                        }}
                      />
                    </motion.div>
                  </AnimatePresence>

                  {/* Navigation Arrows */}
                  {products[activeProduct].images.length > 1 && (
                    <>
                      <button
                        onClick={prevImage}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-gray-800/90 hover:bg-white dark:hover:bg-gray-700 rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 backdrop-blur-sm"
                        aria-label={t(
                          "dehydratedFruits.navigation.previousImage"
                        )}
                      >
                        <FaChevronLeft className="text-amber-600 text-2xl" />
                      </button>
                      <button
                        onClick={nextImage}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-gray-800/90 hover:bg-white dark:hover:bg-gray-700 rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 backdrop-blur-sm"
                        aria-label={t("dehydratedFruits.navigation.nextImage")}
                      >
                        <FaChevronRight className="text-amber-600 text-2xl" />
                      </button>
                    </>
                  )}

                  {/* Image Indicators */}
                  {products[activeProduct].images.length > 1 && (
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-3 bg-black/30 backdrop-blur-md rounded-full px-4 py-2">
                      {products[activeProduct].images.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setActiveImageIndex(index)}
                          className={`transition-all duration-300 rounded-full ${
                            activeImageIndex === index
                              ? "bg-white w-10 h-3"
                              : "bg-white/50 hover:bg-white/75 w-3 h-3"
                          }`}
                          aria-label={t(
                            "dehydratedFruits.navigation.goToImage",
                            { number: index + 1 }
                          )}
                        />
                      ))}
                    </div>
                  )}

                  {/* Image Counter */}
                  <div className="absolute top-4 right-4 bg-black/50 backdrop-blur-md text-white px-4 py-2 rounded-full text-sm font-semibold">
                    {t("dehydratedFruits.products.labels.imageCounter", {
                      current: activeImageIndex + 1,
                      total: products[activeProduct].images.length,
                    })}
                  </div>
                  {/* Decorative sun rays */}
                  <div className="absolute inset-0 opacity-20 pointer-events-none">
                    <FaSun className="absolute top-4 right-4 text-6xl text-white animate-pulse" />
                  </div>
                </div>

                {/* Product Details */}
                <div className="p-8 md:p-12">
                  <div className="flex items-center space-x-3 mb-4">
                    <span
                      className={`px-4 py-1 rounded-full text-sm font-bold ${
                        products[activeProduct].type === "pulp"
                          ? "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400"
                          : "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
                      }`}
                    >
                      {products[activeProduct].type === "pulp"
                        ? t("fruitJuicesPulp.productFamily.labels.pulp")
                        : t(
                            "fruitJuicesPulp.productFamily.labels.readyToDrink"
                          )}
                    </span>
                  </div>

                  <h3 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                    {products[activeProduct].name}
                  </h3>

                  {/* Pulp Products */}
                  {products[activeProduct].type === "pulp" && (
                    <>
                      {/* Sensory Profile */}
                      <div className="space-y-4 mb-6">
                        <div>
                          <span className="font-bold text-orange-600">
                            {t(
                              "fruitJuicesPulp.productFamily.labels.appearance"
                            )}
                            :
                          </span>
                          <span className="text-gray-700 dark:text-gray-300 ml-2">
                            {products[activeProduct].appearance}
                          </span>
                        </div>
                        <div>
                          <span className="font-bold text-orange-600">
                            {t("fruitJuicesPulp.productFamily.labels.aroma")}:
                          </span>
                          <span className="text-gray-700 dark:text-gray-300 ml-2">
                            {products[activeProduct].aroma}
                          </span>
                        </div>
                        <div>
                          <span className="font-bold text-orange-600">
                            {t("fruitJuicesPulp.productFamily.labels.flavour")}:
                          </span>
                          <span className="text-gray-700 dark:text-gray-300 ml-2">
                            {products[activeProduct].flavour}
                          </span>
                        </div>
                        <div>
                          <span className="font-bold text-orange-600">
                            {t("fruitJuicesPulp.productFamily.labels.texture")}:
                          </span>
                          <span className="text-gray-700 dark:text-gray-300 ml-2">
                            {products[activeProduct].texture}
                          </span>
                        </div>
                      </div>

                      {/* Ingredient */}
                      <div className="bg-orange-50 dark:bg-gray-700 rounded-xl p-6 mb-6">
                        <h4 className="font-bold text-orange-600 dark:text-orange-400 mb-2">
                          {t("fruitJuicesPulp.productFamily.labels.ingredient")}
                          :
                        </h4>
                        <p className="text-gray-700 dark:text-gray-300 text-lg">
                          {products[activeProduct].ingredient}
                        </p>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                          <strong>
                            {t("fruitJuicesPulp.productFamily.labels.freeFrom")}
                            :
                          </strong>{" "}
                          {t("fruitJuicesPulp.productFamily.freeFromText")}
                        </p>
                      </div>

                      {/* Usage */}
                      <div className="mb-6">
                        <h4 className="font-bold text-gray-900 dark:text-white mb-3">
                          {t("fruitJuicesPulp.productFamily.labels.usage")}:
                        </h4>
                        <div className="grid grid-cols-2 gap-3">
                          {products[activeProduct].usage.map((use, i) => (
                            <div
                              key={i}
                              className="flex items-center space-x-2 bg-gradient-to-r from-orange-100 to-pink-100 dark:from-orange-900/20 dark:to-pink-900/20 rounded-lg p-3"
                            >
                              <FaCheckCircle className="text-orange-600 flex-shrink-0" />
                              <span className="text-gray-700 dark:text-gray-300 text-sm">
                                {use}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Drink Products */}
                  {products[activeProduct].type === "drink" && (
                    <>
                      {/* Ingredients */}
                      <div className="bg-blue-50 dark:bg-gray-700 rounded-xl p-6 mb-6">
                        <h4 className="font-bold text-blue-600 dark:text-blue-400 mb-2">
                          {t(
                            "fruitJuicesPulp.productFamily.labels.ingredients"
                          )}
                          :
                        </h4>
                        <p className="text-gray-700 dark:text-gray-300">
                          {products[activeProduct].ingredients}
                        </p>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                          <strong>
                            {t("fruitJuicesPulp.productFamily.labels.freeFrom")}
                            :
                          </strong>{" "}
                          {t("fruitJuicesPulp.productFamily.drinkFreeFromText")}
                        </p>
                      </div>

                      {/* Volumes */}
                      <div className="bg-purple-50 dark:bg-gray-700 rounded-xl p-6 mb-6">
                        <h4 className="font-bold text-purple-600 dark:text-purple-400 mb-2">
                          {t(
                            "fruitJuicesPulp.productFamily.labels.availableVolumes"
                          )}
                          :
                        </h4>
                        <p className="text-gray-700 dark:text-gray-300">
                          {products[activeProduct].volumes}
                        </p>
                      </div>

                      {/* Taste Profile */}
                      <div className="mb-6">
                        <h4 className="font-bold text-gray-900 dark:text-white mb-2">
                          {t(
                            "fruitJuicesPulp.productFamily.labels.tasteProfile"
                          )}
                          :
                        </h4>
                        <p className="text-gray-700 dark:text-gray-300 italic">
                          {products[activeProduct].tasteProfile}
                        </p>
                      </div>

                      {/* Serving Ideas */}
                      <div className="mb-6">
                        <h4 className="font-bold text-gray-900 dark:text-white mb-3">
                          {t(
                            "fruitJuicesPulp.productFamily.labels.servingIdeas"
                          )}
                          :
                        </h4>
                        <div className="grid grid-cols-1 gap-3">
                          {products[activeProduct].servingIdeas.map(
                            (idea, i) => (
                              <div
                                key={i}
                                className="flex items-center space-x-2 bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900/20 dark:to-purple-900/20 rounded-lg p-3"
                              >
                                <FaCocktail className="text-blue-600 flex-shrink-0" />
                                <span className="text-gray-700 dark:text-gray-300 text-sm">
                                  {idea}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Common Specs */}
                  <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="font-bold text-gray-900 dark:text-white">
                          {t("fruitJuicesPulp.productFamily.labels.origin")}:
                        </span>
                        <p className="text-gray-600 dark:text-gray-400">
                          {t("fruitJuicesPulp.productFamily.originValue")}
                        </p>
                      </div>
                      <div>
                        <span className="font-bold text-gray-900 dark:text-white">
                          {t("fruitJuicesPulp.productFamily.labels.shelfLife")}:
                        </span>
                        <p className="text-gray-600 dark:text-gray-400">
                          {t("fruitJuicesPulp.productFamily.shelfLifeValue")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Process Description */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-8 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 text-white shadow-xl"
            >
              <div className="flex items-start space-x-4">
                <FaBlender className="text-5xl flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-2xl font-bold mb-3">
                    {t("fruitJuicesPulp.process.title")}
                  </h3>
                  <p className="text-lg leading-relaxed">
                    {t("fruitJuicesPulp.process.description")}
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </section>

        {/* Certifications */}
        <section className="bg-white dark:bg-gray-800 py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 dark:text-white mb-12">
              {t("dehydratedFruits.certifications.title")}
            </h2>

            <div className="flex flex-wrap justify-center items-center gap-6 max-w-5xl mx-auto">
              {certifications.map((cert, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  whileHover={{ scale: 1.1 }}
                  className="group"
                >
                  <div className="flex flex-col items-center space-y-2">
                    <div className="w-16 h-16 flex items-center justify-center bg-orange-50 dark:bg-gray-700 rounded-xl p-2 group-hover:bg-orange-100 dark:group-hover:bg-gray-600 transition-colors">
                      <img
                        src={cert.image}
                        alt={cert.alt}
                        className="max-w-full max-h-full object-contain"
                        onError={(e) => {
                          e.target.style.display = "none";
                          const fallback = document.createElement("span");
                          fallback.className = "text-2xl";
                          fallback.textContent = cert.icon;
                          e.target.parentElement.appendChild(fallback);
                        }}
                      />
                    </div>
                    <span className="text-xs font-semibold text-gray-700 dark:text-gray-300 text-center max-w-[80px]">
                      {cert.name}
                    </span>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Quality & Safety */}
        <section className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-5xl mx-auto"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 dark:text-white mb-12">
              {t("fruitJuicesPulp.quality.title")}
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                {
                  icon: <FaShieldAlt />,
                  title: t("fruitJuicesPulp.quality.brcAligned.title"),
                  desc: t("fruitJuicesPulp.quality.brcAligned.desc"),
                },
                {
                  icon: <FaBarcode />,
                  title: t("fruitJuicesPulp.quality.traceability.title"),
                  desc: t("fruitJuicesPulp.quality.traceability.desc"),
                },
                {
                  icon: <FaCertificate />,
                  title: t("fruitJuicesPulp.quality.verifiedQuality.title"),
                  desc: t("fruitJuicesPulp.quality.verifiedQuality.desc"),
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg text-center hover:shadow-2xl transition-all duration-300"
                >
                  <div className="text-5xl text-orange-600 mb-4 flex justify-center">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {item.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </section>

        {/* Usage & Storage */}
        <section className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 md:p-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
                {t("fruitJuicesPulp.storage.title")}
              </h2>
              <div className="grid md:grid-cols-3 gap-8">
                {[
                  {
                    icon: <FaSnowflake />,
                    title: t("fruitJuicesPulp.storage.bestServed.title"),
                    text: t("fruitJuicesPulp.storage.bestServed.text"),
                  },
                  {
                    icon: <FaGlassWhiskey />,
                    title: t("fruitJuicesPulp.storage.afterOpening.title"),
                    text: t("fruitJuicesPulp.storage.afterOpening.text"),
                  },
                  {
                    icon: <FaBoxOpen />,
                    title: t("fruitJuicesPulp.storage.storageTips.title"),
                    text: t("fruitJuicesPulp.storage.storageTips.text"),
                  },
                ].map((item, i) => (
                  <div key={i} className="text-center">
                    <div className="text-5xl text-orange-600 mb-4 flex justify-center">
                      {item.icon}
                    </div>
                    <h3 className="font-bold text-gray-900 dark:text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-700 dark:text-gray-300">
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section - Add after Technical Specs */}
        <section className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <div className="text-center mb-12">
              <motion.div
                initial={{ scale: 0.9 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                className="inline-block mb-4"
              >
                <span className="px-6 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full text-sm font-semibold shadow-lg">
                  {t("fruitJuicesPulp.faq.badge")}
                </span>
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
                {t("fruitJuicesPulp.faq.title")}
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-300">
                {t("fruitJuicesPulp.faq.subtitle")}
              </p>
            </div>

            <div className="space-y-4">
              {faqKeys.map((key, index) => (
                <motion.div
                  key={key}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden border-2 border-transparent hover:border-orange-500 transition-all duration-300"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === key ? null : key)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  >
                    <span className="font-bold text-lg text-gray-900 dark:text-white pr-8">
                      {t(`fruitJuicesPulp.faq.questions.${key}.question`)}
                    </span>
                    <motion.div
                      animate={{ rotate: openFaq === key ? 180 : 0 }}
                      transition={{ duration: 0.3 }}
                      className="flex-shrink-0"
                    >
                      <FaChevronDown className="text-orange-600 text-xl" />
                    </motion.div>
                  </button>

                  <AnimatePresence>
                    {openFaq === key && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        <div className="px-6 pb-5 text-gray-600 dark:text-gray-300 leading-relaxed">
                          {t(`fruitJuicesPulp.faq.questions.${key}.answer`)}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </section>

        {/* Technical Specs Teaser - Add before FAQ */}
        <section className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-5xl mx-auto bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 md:p-12 text-white shadow-2xl"
          >
            <div className="text-center">
              <FaDownload className="text-6xl mb-4 mx-auto" />
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                {t("fruitJuicesPulp.technical.title")}
              </h2>
              <p className="text-lg mb-6 opacity-90">
                {t("fruitJuicesPulp.technical.description")}
              </p>
              <button
                onClick={() => setShowDownloadModal(true)}
                className="bg-white text-indigo-600 px-8 py-3 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:scale-105 active:scale-95 flex items-center space-x-2 mx-auto"
              >
                <FaDownload />
                <span>{t("fruitJuicesPulp.technical.downloadButton")}</span>
              </button>
            </div>
          </motion.div>
        </section>

        {/* Bottom Spacer */}
        <div className="h-16"></div>
      </div>
    </>
  );
};

export default FruitJuicesPulp;
